import actions from './actions';
import mutations from './mutations';
import { uploadForm } from './state';

function state() {
    return {
        uploadDialogOpen: false,
        isSaving: false,

        formData: uploadForm(),
        formRef: null,
        
        validations: [],
        previewImage: null
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};